import { render, staticRenderFns } from "./ScheduledMessages.vue?vue&type=template&id=188bbc6a&scoped=true"
import script from "./ScheduledMessages.vue?vue&type=script&lang=js"
export * from "./ScheduledMessages.vue?vue&type=script&lang=js"
import style0 from "./ScheduledMessages.vue?vue&type=style&index=0&id=188bbc6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188bbc6a",
  null
  
)

export default component.exports